import { Box, Stack } from '@mui/material'
import { getTips } from 'api/tips'
import ScrollContainer from 'components/page/ScrollContainer'
import FailPlaceholder from 'components/placeholders/FailPlaceholder'
import LoadingPlaceholder from 'components/placeholders/LoadingPlaceholder'
import TableToolbar from 'components/table/TableToolbar'
import { heightOfToolbar } from 'const'
import { UICollapseProvider } from 'features/UI'
import { useMemo } from 'react'
import { useQuery } from 'react-query'
import { EOp } from 'types'
import { TipOrgGroup } from '../TipOrgGroup/TipOrgGroup'

const paddingLeft = { xs: 2, sm: 2 }
const paddingRight = { xs: 1, sm: 2 }

export const TipsOrgTablePage = () => {
  const { data, isLoading, isError } = useQuery('getTips', () =>
    getTips({ filter: { isPublished: { type: 'boolean', op: EOp.equals, value: true } } }),
  )

  const orderedTips = useMemo(() => {
    if (!data) return []

    return data.data.rows.sort((a, b) => {
      const aOrder = a.order ?? 0
      const bOrder = b.order ?? 0
      return aOrder - bOrder
    })
  }, [data])

  if (isLoading) {
    return (
      <Box sx={{ paddingY: 3 }}>
        <LoadingPlaceholder />
      </Box>
    )
  }

  if (isError) {
    return <FailPlaceholder error="Can't load tips" />
  }

  return (
    <>
      <TableToolbar title="Tips Overview" />
      <UICollapseProvider>
        <Stack paddingTop={1} paddingLeft={paddingLeft} paddingRight={paddingRight} spacing={1}>
          <ScrollContainer deltaSpace={heightOfToolbar}>
            {orderedTips.map((item) => (
              <TipOrgGroup key={item.id} tip={item} />
            ))}
          </ScrollContainer>
        </Stack>
      </UICollapseProvider>
    </>
  )
}
